import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useWorkspace } from '../contexts/WorkspaceContext';
import Layout from '../components/Layout';
import TrainingDashboard from '../components/TrainingDashboard';
import apiClient from '../config/axios';
import toast from 'react-hot-toast';
import { ArrowLeft } from 'lucide-react';

const TrainingPage = () => {
  const { chatbotId } = useParams();
  const navigate = useNavigate();
  const { currentWorkspace } = useWorkspace();
  const [chatbot, setChatbot] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchChatbot = async () => {
      try {
        if (chatbotId) {
          const response = await apiClient.get(`/api/chatbot/${chatbotId}`);
          setChatbot(response.data);
        }
      } catch (error) {
        toast.error('Failed to load chatbot');
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchChatbot();
  }, [chatbotId]);

  if (loading) {
    return (
      <Layout>
        <div className="flex items-center justify-center py-12">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="space-y-6">
        {/* Back Button */}
        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center text-sm text-gray-600 hover:text-gray-900"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back
        </button>

        {/* Page Header */}
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <h1 className="text-3xl font-bold text-gray-900">
            {chatbot?.name || 'Training Dashboard'}
          </h1>
          <p className="text-gray-600 mt-2">
            Build and manage your knowledge base to improve auto-reply accuracy and coverage
          </p>
        </div>

        {/* Training Dashboard */}
        {chatbotId && currentWorkspace?.id && (
          <TrainingDashboard chatbotId={chatbotId} workspaceId={currentWorkspace.id} />
        )}
      </div>
    </Layout>
  );
};

export default TrainingPage;
